import { Button, Col, Form, Input, InputNumber, Row, Select, Space, Switch, Tabs, Tag } from "antd";
import PageHeader from "components/PageHeader";
import { Prompt } from "react-router-dom";
import { BUDGET_TIER_LABEL } from "features/ProjectType/core";
import { ProjectTypeState } from "features/ProjectType/presentation/components/ProjectTypeState";
import PackageProductTable from "./components/PackageProductTable";
import usePackageForm from "./usePackageForm";
import "./index.scss";
export default function PackageForm() {
  const vm = usePackageForm();
  return (
    <div className="project-type-page project-type-package-form">
      <Prompt when={vm.dirty} message="Bạn có thay đổi chưa lưu. Bạn có muốn rời trang?" />
      <PageHeader
        pageTitle={vm.pid ? "Chỉnh sửa gói đề xuất" : "Thêm gói đề xuất"}
        routes={[
          { name: "Cài đặt hệ thống", path: "/setting" },
          { name: "Cấu hình loại dự án", path: "/setting/project-type" },
          { name: vm.type.data?.name, path: `/setting/project-type/${vm.id}` },
          { name: "Gói đề xuất" },
        ]}
      />
      <ProjectTypeState loading={vm.loading} error={vm.error} refetch={vm.refetch}>
        <Form
          form={vm.form}
          layout="vertical"
          initialValues={{ isVisible: true }}
          onFinish={vm.save}
          onValuesChange={(changedValues, allValues) => {
            vm.setDirty(true);
            if ("priceFromMillion" in changedValues || "priceToMillion" in changedValues) {
              const from = allValues.priceFromMillion;
              const to = allValues.priceToMillion;
              const hasAtLeastOne = (from != null && from !== "") || (to != null && to !== "");
              if (hasAtLeastOne) {
                const fromErrors = vm.form.getFieldError("priceFromMillion") || [];
                if (fromErrors.includes("Vui lòng nhập ít nhất một đầu giá")) {
                  vm.form.setFields([{ name: "priceFromMillion", errors: [] }]);
                }
              }
              if (from != null && from !== "" && to != null && to !== "" && Number(from) <= Number(to)) {
                const toErrors = vm.form.getFieldError("priceToMillion") || [];
                if (toErrors.includes("Giá từ không được lớn hơn giá đến")) {
                  vm.form.setFields([{ name: "priceToMillion", errors: [] }]);
                }
              }
            }
          }}
        >
          <div className="project-type-card project-type-toolbar project-type-package-header">
            <Space>
              <strong>{vm.type.data?.name}</strong>
              <Form.Item noStyle shouldUpdate={(prev, next) => prev.budgetTier !== next.budgetTier}>
                {() => <Tag color="blue">Mức {BUDGET_TIER_LABEL[vm.form.getFieldValue("budgetTier")] || "—"}</Tag>}
              </Form.Item>
            </Space>
            <Space>
              <Button disabled={vm.saving} onClick={vm.cancel}>
                Hủy
              </Button>
              <Button type="primary" htmlType="submit" loading={vm.saving}>
                Lưu gói đề xuất
              </Button>
            </Space>
          </div>
          <fieldset disabled={vm.saving}>
            <div className="project-type-card">
              <h3>Thông tin gói</h3>
              <Row gutter={20}>
                <Col span={12}>
                  <Form.Item label="Loại dự án">
                    <Input readOnly value={vm.type.data?.name} className="project-type-readonly" />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    name="budgetTier"
                    label="Mức ngân sách"
                    rules={[{ required: true, message: "Vui lòng chọn mức ngân sách" }]}
                  >
                    <Select
                      disabled={vm.saving}
                      options={Object.entries(BUDGET_TIER_LABEL).map(([value, label]) => ({ value, label }))}
                    />
                  </Form.Item>
                </Col>
                {[
                  ["name", "Tên gói"],
                  ["title", "Tiêu đề gói"],
                ].map(([name, label]) => (
                  <Col span={12} key={name}>
                    <Form.Item
                      name={name}
                      label={label}
                      rules={[
                        { required: true, whitespace: true, message: `Vui lòng nhập ${label.toLowerCase()}` },
                        { max: 255, message: "Tối đa 255 ký tự" },
                      ]}
                    >
                      <Input />
                    </Form.Item>
                  </Col>
                ))}
                <Col span={12}>
                  <Form.Item name="shortDescription" label="Mô tả ngắn">
                    <Input.TextArea rows={3} placeholder="Mỗi dòng một ý, hiện có dấu tích trên app" />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item label="Khoảng giá tham khảo" required>
                    <Space align="start">
                      <Form.Item
                        name="priceFromMillion"
                        style={{ marginBottom: 0 }}
                        dependencies={["priceToMillion"]}
                        rules={[
                          {
                            validator: () => {
                              const from = vm.form.getFieldValue("priceFromMillion");
                              const to = vm.form.getFieldValue("priceToMillion");
                              const emptyFrom = from == null || from === "";
                              const emptyTo = to == null || to === "";
                              if (emptyFrom && emptyTo) {
                                return Promise.reject(new Error("Vui lòng nhập ít nhất một đầu giá"));
                              }
                              if (!emptyFrom && from < 0) {
                                return Promise.reject(new Error("Giá phải ≥0"));
                              }
                              return Promise.resolve();
                            },
                          },
                        ]}
                      >
                        <InputNumber style={{ width: 150 }} placeholder="Từ (triệu)" aria-label="Giá từ (triệu)" />
                      </Form.Item>
                      <span style={{ lineHeight: "36px" }}>triệu –</span>
                      <Form.Item
                        name="priceToMillion"
                        style={{ marginBottom: 0 }}
                        dependencies={["priceFromMillion"]}
                        rules={[
                          {
                            validator: () => {
                              const from = vm.form.getFieldValue("priceFromMillion");
                              const to = vm.form.getFieldValue("priceToMillion");
                              const emptyFrom = from == null || from === "";
                              const emptyTo = to == null || to === "";
                              if (!emptyTo && to < 0) {
                                return Promise.reject(new Error("Giá phải ≥0"));
                              }
                              if (!emptyFrom && !emptyTo && Number(from) > Number(to)) {
                                return Promise.reject(new Error("Giá từ không được lớn hơn giá đến"));
                              }
                              return Promise.resolve();
                            },
                          },
                        ]}
                      >
                        <InputNumber style={{ width: 170 }} placeholder="Đến (triệu)" aria-label="Giá đến (triệu)" />
                      </Form.Item>
                      <span style={{ lineHeight: "36px" }}>triệu VNĐ</span>
                    </Space>
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    name="priceNote"
                    label="Ghi chú dưới tổng giá"
                    rules={[{ max: 255, message: "Tối đa 255 ký tự" }]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item name="isVisible" label="Hiển thị trên app" valuePropName="checked">
                    <Switch disabled={vm.saving} />
                  </Form.Item>
                </Col>
              </Row>
            </div>
            <div className="project-type-card">
              <Tabs>
                <Tabs.TabPane key="products" tab={`Sản phẩm trong gói (${vm.products.length})`}>
                  <PackageProductTable
                    products={vm.products}
                    onChange={vm.setProducts}
                    errors={vm.productErrors}
                    disabled={vm.saving}
                  />
                </Tabs.TabPane>
              </Tabs>
            </div>
          </fieldset>
        </Form>
      </ProjectTypeState>
    </div>
  );
}
